import React from "react";
import "./Hamburguer.scss";

const Hamburguer = (props) => {
  return (
    <div
      onClick={props.handleClick}
      className={`icon nav-icon-8 ${props.clicked ? "open" : ""}`}
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Hamburguer;
